import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import MessageGroup from './message_group';
import Loader from '../loader';
import ModalConfirm from '../modal/modal_confirm';

export default createReactClass({
  displayName: 'Root',
  loadMessageGroupListFromServer() {
    var companyId =
      typeof this.props.companyId === 'undefined' ? null : this.props.companyId;
    $.ajax({
      url: '/api/message/index',
      data: {
        company_id: companyId,
      },
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({
          loading: false,
          data: data,
        });
      }.bind(this),
      error: function () {}.bind(this),
    });
  },
  loadMoreMessageGroupListFromServer(page) {
    var companyId =
      typeof this.props.companyId === 'undefined' ? null : this.props.companyId;
    $.ajax({
      url: '/api/message/index',
      data: {
        company_id: companyId,
        page: page + 1,
      },
      dataType: 'json',
      cache: false,
      success: function (data) {
        let newData = this.state.data;
        const currentGroupIds = this.state.data.messageGroups.map(
          (group) => group.id
        );
        newData.messageGroups = newData.messageGroups.concat(
          data.messageGroups.filter(
            (group) => !currentGroupIds.includes(group.id)
          )
        );
        newData.pagenationSettings = data.pagenationSettings;
        this.setState({
          loading: false,
          data: newData,
        });
      }.bind(this),
      error: function () {}.bind(this),
    });
  },
  propTypes: {
    messageGroupId: PropTypes.number,
    isCompany: PropTypes.bool,
  },
  getInitialState() {
    return {
      loading: true,
      data: {
        messageGroups: [],
        currentUserId: 0,
        pagenationSettings: {
          currentPage: 0,
          maxPerPage: 0,
          isLastPage: false,
        },
      },
      modalConfirmRef: React.createRef(),
    };
  },
  componentDidMount() {
    this.loadMessageGroupListFromServer();
    // $(window).on('focus', function() {
    //     this.loadMessageGroupListFromServer();
    //  }.bind(this));
    setInterval(this.loadMessageGroupListFromServer, 130000);
  },
  render() {
    var currentUserId = this.state.data.currentUserId;
    var messageGroupId = this.props.messageGroupId;
    var isCompany = this.props.isCompany;
    var lastGroup =
      this.state.data.messageGroups[this.state.data.messageGroups.length - 1];
    const isLastPage = this.state.data.pagenationSettings.isLastPage;
    const currentPage = this.state.data.pagenationSettings.currentPage;
    var messageGroup = this.state.data.messageGroups.map((group) => {
      return (
        <MessageGroup
          isCompany={isCompany}
          messageGroup={group}
          currentUserId={currentUserId}
          messageGroupId={messageGroupId}
          hasUnreadMessage={false}
          key={group.id}
          isLast={lastGroup == group}
          unreadMessageCount={this.state.data.unreadMessageCount[group.id]}
          lastMessage={this.state.data.lastMessages[group.id]}
        />
      );
    });
    var messageGroupList = <p>メッセージがありません。</p>;
    const appLinkButton = isLastPage ? (
      ''
    ) : (
      <li
        onClick={() => this.loadMoreMessageGroupListFromServer(currentPage)}
        className="hov--default"
      >
        <div className="row justify-content-around align-items-center pt-3 pb-3 border-top">
          もっとみる
        </div>
      </li>
    );
    if (this.state.data.messageGroups) {
      messageGroupList = (
        <ul className="list-unstyled" style={{ marginBottom: '75px' }}>
          {messageGroup}
          {appLinkButton}
        </ul>
      );
    }
    return (
      <div>
        {this.state.data.messageGroups.length > 0 ? (
          <div className="container col-md-8 col-lg-6">
            <h6 className="h6--list-title text-fz-14px text-black-50">
              個人間メッセージ
            </h6>
          </div>
        ) : null}
        <div className="bg-white h-100 mb-2">
          <div className="container col-md-8 col-lg-6 h-100">
            <Loader isActive={this.state.loading} />
            {messageGroupList}
          </div>
        </div>
      </div>
    );
  },
});
